import { render, staticRenderFns } from "./MyPassword.vue?vue&type=template&id=09df0d4c&"
import script from "./MyPassword.vue?vue&type=script&lang=ts&"
export * from "./MyPassword.vue?vue&type=script&lang=ts&"
import style0 from "./MyPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports